<template>
  <div>
    <v-btn
      color="primary"
      dark
      class="mb-2"
      @click="add = true"
    >
      Add Okta Federation Group
    </v-btn>
    <v-btn
      color="primary"
      dark
      class="mb-2"
      @click="$emit('close')"
    >
      Back to Federations
    </v-btn>
    <federation-groups-table-modal v-if="add" :user-groups="userGroups" :federation-id="federationId" @close="add = false" />
    <v-data-table
      :headers="tableHeaders"
      :items="tableItemsGroups"
      class="elevation-1"
      disable-pagination
      hide-default-footer
    >
      <template v-slot:item="props">
        <tr>
          <td class="justify-center">
            <v-btn tooltip.hover title="Delete Role User Group" icon class="mx-0" @click="deleteGroup(props.item[0], props.item[1].userGroupId)">
              <v-icon color="primary">delete</v-icon>
            </v-btn>
          </td>
          <td>{{ props.item[0] }}</td>
          <td>{{ props.item[1].userGroupName }}</td>
          <td>{{ props.item[1].userGroupDesc }}</td>
        </tr>
      </template>
    </v-data-table>
  </div>
</template>

<script>

import FederationGroupsTableModal from './FederationGroupsTableModal'
import { mapActions } from 'vuex'
import find from 'lodash/find'

export default {
  name: 'client-table',
  components: {
    FederationGroupsTableModal
  },
  props: {
    tableItems: Array,
    userGroups: Array,
    federationId: Number
  },
  data() {
    return {
      add: false,
      tableHeaders: [
        {
          text: 'Delete',
          value: false,
          sortable: false
        },
        {
          text: 'Okta Group (Role)',
          value: '[0]'
        },
        {
          text: 'User Group',
          value: '[1].userGroupName'
        },
        {
          text: 'User Group Description',
          value: '[1].userGroupDesc'
        }
      ]
    }
  },
  computed: {
    tableItemsGroups() {
      return this.tableItems.map(item => [Object.keys(item)[0], find(this.userGroups, { userGroupId: Object.values(item)[0] })])
    }
  },
  methods: {
    ...mapActions('oktaFederations', ['deleteFederationSsoGroup']),
    deleteGroup(roleName, userGroupId) {
      this.deleteFederationSsoGroup({ federationId: this.federationId, roleName: roleName, userGroupId: userGroupId })
    }
  }
}
</script>
